/*
 * Size guide drawer
 * - Lazy-boots the Anagram finder the first time a size-guide drawer opens, so
 *   the third-party boot.js is not requested on every PDP (mirrors
 *   assets/armada-find-in-store-modal.js).
 * - Wires the CM/INCH unit toggle and the finder chips inside each drawer.
 */
(() => {
  const initUnitToggle = (scope) => {
    scope.querySelectorAll('[data-unit-table]').forEach((table) => {
      const group = table.closest('.size-guide-chart-block') || table.parentElement;
      const unitBtns = group ? group.querySelectorAll('[data-unit-btn]') : [];
      if (!unitBtns.length) return;
      unitBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const unit = btn.dataset.unitBtn;
          unitBtns.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
          table.querySelectorAll('td[data-cm]').forEach((cell) => {
            cell.textContent = cell.dataset[unit] || cell.dataset.cm;
          });
        });
      });
    });
  };

  const initTabs = (modal) => {
    const tabs = modal.querySelectorAll('[data-sg-tab]');
    if (!tabs.length) return;
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const targetId = tab.getAttribute('aria-controls');
        tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', active ? 'true' : 'false');
          t.classList.toggle('size-guide-modal__tab--active', active);
          t.classList.toggle('size-guide-modal__tab--inactive', !active);
        });
        modal.querySelectorAll('.size-guide-modal__panel').forEach((panel) => {
          if (panel.id === targetId) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  };

  // Table cells are authored as plain CSV; a cell may contain a link written as
  // [label](url). Turn those into anchors after render (pure Liquid can't parse
  // them). Only cells that actually contain a markdown link are touched, so the
  // numeric CM/INCH cells the unit toggle rewrites are never affected.
  const escapeHtml = (s) =>
    s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const linkify = (text) => {
    const md = /\[([^\]]+)\]\(([^)]+)\)/g;
    let out = '';
    let last = 0;
    let m;
    while ((m = md.exec(text))) {
      out += escapeHtml(text.slice(last, m.index));
      const url = m[2].trim();
      const safe = /^(https?:\/\/|\/|mailto:)/i.test(url) ? url.replace(/"/g, '%22') : '#';
      out += `<a href="${escapeHtml(safe)}">${escapeHtml(m[1])}</a>`;
      last = m.index + m[0].length;
    }
    out += escapeHtml(text.slice(last));
    return out;
  };
  const initTableLinks = (scope) => {
    scope.querySelectorAll('td[data-sg-md]').forEach((cell) => {
      const raw = cell.textContent;
      if (!/\[[^\]]+\]\([^)]+\)/.test(raw)) return;
      cell.innerHTML = linkify(raw);
    });
  };

  const initChips = (scope) => {
    const chips = scope.querySelectorAll('[data-chip-btn]');
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((c) => c.classList.remove('is-active'));
        chip.classList.add('is-active');
      });
    });
  };

  // AAS-5381: size-guide-block.liquid omits the embed while
  // `enable_anagram_ask_ai` is off, so this returns before boot.js is requested.
  const initAnagram = (modal) => {
    const embed = modal.querySelector('.size-guide-finder__embed[data-anagram-experience]');
    if (!embed) return;
    let booted = false;
    const boot = () => {
      if (booted) return;
      booted = true;
      const script = document.createElement('script');
      script.defer = true;
      script.src = 'https://studio.anagram.ai/boot.js';
      script.setAttribute('data-experience', embed.getAttribute('data-anagram-experience'));
      embed.appendChild(script);
    };
    const observer = new MutationObserver(() => {
      if (modal.hasAttribute('open')) {
        boot();
        observer.disconnect();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  };

  const init = () => {
    document.querySelectorAll('modal-dialog.product-popup-modal--size-guide').forEach((modal) => {
      if (modal.dataset.sgInit === 'true') return;
      modal.dataset.sgInit = 'true';
      initTabs(modal);
      initUnitToggle(modal);
      initTableLinks(modal);
      initChips(modal);
      initAnagram(modal);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
